import { lastDays, useDashboard } from "@/lib/api/dashboard";
import { useList } from "@/lib/api/queries";
import { PERM } from "@/lib/auth/rbac";

/**
 * Menyu qatoridagi sanoq tabletkalari.
 *
 * YANGI so'rov qo'shilmaydi: har biri sahifalar allaqachon
 * ishlatayotgan so'rov bilan BIR XIL kalitda — kesh umumiy va
 * jonli oqim (SSE) ularni o'zi yangilaydi. Vakolat bo'lmasa so'rov
 * umuman yuborilmaydi: 403 xatosi bilan konsolni to'ldirish
 * ma'nosiz.
 *
 * Rang faqat ma'no bo'lganda: dead-letter — xato (qizil), qolgani
 * neytral kulrang.
 */
export interface NavCount {
  count: number;
  /** `+` — server ro'yxati chegaraga urildi, haqiqiy son ko'proq. */
  more?: boolean;
  tone?: "error" | "warning";
  hint: string;
}

/** Buyurtma yakunlangan holatlar — sanoqqa kirmaydi. */
const ORDER_DONE = new Set([
  "SHIPPED",
  "DELIVERED",
  "HANDED_OFF",
  "COMPLETED",
  "CLOSED",
  "CANCELLED",
]);

interface StatusCountRow {
  status: string;
  count: number;
}

export function useNavCounts(permissions: string[]): Record<string, NavCount> {
  const canReport = permissions.includes(PERM.reportRead);
  const canPicking = permissions.includes(PERM.pickingRead);
  const canIntegration = permissions.includes(PERM.integrationRead);

  // Oraliq boshqaruv panelining sukut bo'yicha oralig'i bilan bir
  // xil — so'rov kaliti umumiy, ikkinchi marta yuborilmaydi.
  const dashboard = useDashboard(lastDays(1), null, { enabled: canReport });
  const picking = useList<StatusCountRow>(
    "picking",
    "/api/v1/picking/orders/counts",
    {},
    { enabled: canPicking },
  );
  const deadLetter = useList<{ id: string }>(
    "integration",
    "/api/v1/integration/dead-letter",
    { limit: 200 },
    { enabled: canIntegration },
  );

  const counts: Record<string, NavCount> = {};

  const open = dashboard.data?.open;
  if (open) {
    const total = open.reduce((sum, row) => sum + row.count, 0);
    if (total > 0) counts["/tasks"] = { count: total, hint: `${total} ta ochiq topshiriq` };
  }

  const orders = picking.data?.items;
  if (orders) {
    const active = orders
      .filter((row) => !ORDER_DONE.has(row.status))
      .reduce((sum, row) => sum + row.count, 0);
    if (active > 0) counts["/orders"] = { count: active, hint: `${active} ta faol buyurtma` };
  }

  const dead = deadLetter.data;
  if (dead && dead.items.length > 0) {
    counts["/integration"] = {
      count: dead.items.length,
      more: dead.has_more,
      tone: "error",
      hint: `${dead.items.length}${dead.has_more ? "+" : ""} ta xabar ko'rib chiqishni kutmoqda`,
    };
  }

  return counts;
}
